import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 md:gap-14">
          <div className="flex-1">
            <div className="relative rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20minimalist%20desk%20with%20laptop%20displaying%20colorful%20organized%20product%20spreadsheet%20with%20multiple%20data%20columns%2C%20warm%20cream%20surface%2C%20soft%20natural%20window%20light%20casting%20gentle%20shadows%2C%20small%20green%20potted%20succulent%20plant%20on%20side%2C%20leather%20bound%20notebook%2C%20editorial%20productive%20workspace%20photography%2C%20neutral%20beige%20and%20warm%20terracotta%20tones%2C%20inviting%20organized%20atmosphere&width=700&height=500&seq=vigorbuy-about-2026&orientation=landscape"
                alt="Vigorbuy Spreadsheet organized product data"
                title="Vigorbuy Spreadsheet organized product data"
                className="w-full h-auto rounded-2xl"
              />
            </div>
          </div>
          <div className="flex-1">
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              About The Platform
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-5">
              What Is Vigorbuy Spreadsheet?
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              Vigorbuy Spreadsheet is an organized shopping resource that helps users discover products, compare information, and save research time. Unlike traditional online shopping where you navigate through endless pages, Vigorbuy Spreadsheet consolidates product data into a structured format that makes browsing faster and more efficient.
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              Whether you are looking for the latest sneakers, trending streetwear, classic accessories, or everyday essentials, the platform organizes everything into clear categories. Each product entry includes relevant details so you can make informed decisions without jumping between multiple tabs and websites.
            </p>

            <div className="grid grid-cols-2 gap-4 mb-8">
              {[
                { title: 'Organized Data', desc: 'Structured product information at a glance' },
                { title: 'Fast Browsing', desc: 'Quick category navigation saves time' },
                { title: 'Easy Comparison', desc: 'Compare products side by side easily' },
                { title: 'Regular Updates', desc: 'Product listings refreshed consistently' },
              ].map((item) => (
                <div key={item.title} className="flex items-start gap-2.5">
                  <div className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-100 mt-0.5 flex-shrink-0">
                    <i className="ri-check-line text-accent-600 text-xs"></i>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{item.title}</p>
                    <p className="text-xs text-foreground-500">{item.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <Link
              to="/article/vigorbuy-spreadsheet-complete-guide"
              className="inline-flex items-center gap-2 px-5 py-3 rounded-xl text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              Learn More In Our Guide
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}